var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator","color":_vm.color},slot:"activator"},[_vm._v(_vm._s(_vm.iconString))]),_c('span',[_vm._v(_vm._s(_vm.value ? _vm.$t('term.enabled') : _vm.$t('term.disabled')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }